var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuantityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 34,
    fill: "url(#pattern0_1575_25)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1575_25",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1575_25",
    transform: "scale(0.0285714 0.0294118)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1575_25",
    width: 35,
    height: 34,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAiCAYAAADVhWD8AAABwklEQVRYhe2XPU/DMBCGn9DSQhGIT8ECAwsDCwsDLPxvNmYWGBgYQALEh4RAAsRnmwZZeo1Opg4pKQKkPJKV1DnXry++3DnhaxrABjAaWLqxNV09GdBVs7SBXeA+b7Z6ATHjwEQBOyuwFvQPA7ODEGPZM/fTwBLQAS6AOXnvGjg3dis9vDoQMWfB7yW9gn1gXZM+BHbLRcUM9SnmR+nXM71oApvaW6UoIybV1Xl3pkd/35QRcwUcKFI8LqRPfkOMm/i4xPhP/KkNXImJUYmJUYmJkeijtRp8vFAZMK6rf9ZVls6MXaLvVdqjjqmbcqKj9qjkanHjDp3xPLBYUPyQiq3YszzqaiMRm+e6qdSc6lPzcEot1Uqasn0B3ozdmFafqXywXmnp/lVinYeflEo8C7JLbDpoK9d4ViTGuXUH2FLFdxSkAd/fkZ2dZF3328Ca3sB9ME/Li/530TSiDR5710VYlZdzycvaPjIaKh37xUaWHZ/F/idPjCuqJ4OQd/vqsqCoG9XCLdOX5pUdeWKedNb5LmlwmviSKh3EqMTEqMTEsKEdHsaK4kuE5JvjP6qARMlrbVCrK8Gx88adMu5vkgG37xn/TtVlCcXtAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantityIcon);
export default __webpack_public_path__ + "static/media/quantity-icon.f090ad69b69803bd1adbb9873b88ed5c.svg";
export { ForwardRef as ReactComponent };